import React from "react";
import styled from "styled-components";
import { CardMedia } from "@mui/material";
import { useTranslation } from "react-i18next";
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import InstagramIcon from "../images/Instagram_Glyph_Black.png";
import FacebookIcon from "../images/Facebook_Logo_Secondary.png";
import Clinic from "../images/Clinic.jpg";

const PageContainer = styled.div``;

const Title = styled.h1`
  text-align: center;
  margin: 0 0 16px 0;
  color: rgb(104 38 85);
  @media (max-width: 700px) {
  }
`;

const Name = styled.p`
  color: rgb(104 38 85);
  margin: 8px 0;
`;
const Section = styled.div``;

const InfoRow = styled.div`
  display: flex;
  align-items: center;
`;

const InfoText = styled.p`
  margin-left: 10px;
  font-size: 14px;
`;

const SocialIcons = styled.div`
  display: flex;
  gap: 10px;
  margin-top: 10px;
`;

const SocialIcon = styled.img`
  width: 20px;
  height: 20px;
`;

const StyledFacebookIcon = styled(SocialIcon)`
  background-color: black;
  border-radius: 1px;
`;

const ContactUs: React.FC = () => {
  const { t } = useTranslation();

  return (
    <PageContainer>
      <Title>{t("company.contactUs").toUpperCase()}</Title>
      <CardMedia
        component="img"
        sx={{ width: { md: 250 } }}
        image={Clinic}
        alt="Clinic"
      />

      <Section>
        <Name>{t("company.name")}</Name>
      </Section>

      <Section>
        <InfoRow>
          <PhoneIcon sx={{ fontSize: 18, color: "rgb(197 59 108)" }} />
          <InfoText>(619) 754-9500</InfoText>
        </InfoRow>
        <InfoRow>
          <EmailIcon sx={{ fontSize: 18, color: "rgb(197 59 108)" }} />
          <InfoText>{t("company.email")}</InfoText>
        </InfoRow>
        <InfoRow>
          <LocationOnIcon sx={{ fontSize: 18, color: "rgb(197 59 108)" }} />
          <InfoText>{t("company.address")}</InfoText>
        </InfoRow>
      </Section>

      <Section>
        <h4>{t("company.followOnSocial")}</h4>
        <SocialIcons>
          <SocialIcon src={InstagramIcon} alt="Instagram" />
          <StyledFacebookIcon src={FacebookIcon} alt="Facebook" />
        </SocialIcons>
      </Section>
    </PageContainer>
  );
};

export default ContactUs;
